import React, { useState } from 'react';
import Pagination from '../../components/Pagination.js';
import { MdDeleteOutline } from 'react-icons/md';
import DeleteModal from '../../components/Modal/DeleteModal';
import { Table } from 'reactstrap';

function DataTable({
    tableHeader = [],
    data = [],
    allData,
    isDeleteModalOpen,
    setIsDeleteModalOpen,
    pageNumber,
    pageSize,
    totalCount,
    totalPages,
    onPageChange,
    action,
    canDelete = true,
    showCheckBox,
    deleteUrl,
    setSelectedRows,
    selectedRows,
    refetchData,
    onRowClick,
    onSort,
    sortConfig = { key: null, direction: 'asc' },
}) {

    const [selectedDeleteItems, setSelectedDeleteItems] = useState(null);
    const selectAllData = allData || data;
    const handleRowSelect = (row) => {
        setSelectedRows((prev) => {
            const exists = prev.some((r) => r.id === row.id);
            if (exists) {
                return prev.filter((r) => r.id !== row.id);
            } else {
                return [...prev, row];
            }
        });
    };
    const handleSelectAll = () => {
        const allSelected = selectAllData.every((row) => selectedRows.some((r) => r.id === row.id));
        if (allSelected) {
            setSelectedRows((prev) => prev.filter((r) => !selectAllData.some((row) => row.id === r.id)));
        } else {
            const newRows = selectAllData.filter((row) => !selectedRows.some((r) => r.id === row.id));
            setSelectedRows((prev) => [...prev, ...newRows]);
        }
    };

    const handleDeleteSuccessCallback = () => {
        setIsDeleteModalOpen(false);
        setSelectedRows([]);
    };
    return (
        <>
            <div className="card border-0 shadow-sm mb-0">
                <div className="table-responsive">
                    <Table className="mb-0" hover style={{ width: '100%', minWidth: '100%', backgroundColor: '#f0f0f0' }}>
                        <thead >
                            <tr>
                                {showCheckBox && (
                                    <th style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                        <input
                                            style={{
                                                width: '20px',
                                                height: '20px',
                                                cursor: selectAllData.length === 0 ? 'not-allowed' : 'pointer',
                                                paddingBottom: '0px',
                                            }}
                                            type="checkbox"
                                            onChange={handleSelectAll}
                                            disabled={selectAllData.length === 0}
                                            checked={
                                                selectAllData.length > 0 &&
                                                selectAllData.every((row) => selectedRows.some((r) => r.id === row.id))
                                            }
                                        />
                                    </th>
                                )}
                                {tableHeader.map((col) => {
                                    const isSortable = onSort && col.sortable;
                                    return (
                                        <th
                                            key={col.key}
                                            className="text-nowrap"
                                            style={{ cursor: isSortable ? 'pointer' : 'default' }}
                                            onClick={isSortable ? () => onSort(col.key) : undefined}
                                        >
                                            <span style={{ display: 'inline-flex', alignItems: 'center' }}>
                                                {col.label}
                                                {isSortable && sortConfig.key === col.key && (
                                                    <span style={{ marginLeft: '4px' }}>
                                                        {sortConfig.direction === 'asc' ? '▲' : '▼'}
                                                    </span>
                                                )}
                                            </span>
                                        </th>
                                    );
                                })}
                                {action && canDelete && <th>Actions</th>}
                            </tr>
                        </thead>
                        <tbody className="table-group-divider table-hover" style={{ backgroundColor: "white" }}>
                            {data.map((row, index) => {
                                const isSelected = selectedRows.some((r) => r.rxNumber === row.rxNumber);

                                const formatDate = (date) => {
                                    const options = { year: 'numeric', month: 'short', day: 'numeric' };
                                    return date ? new Date(date).toLocaleDateString('en-US', options) : '-';
                                };

                                const formatQuantity = (quantity) => {
                                    return quantity ? quantity : '-';
                                };

                                return (
                                    <tr
                                        key={index}
                                        className={`table-row ${isSelected ? 'selected-row' : ''}`}
                                        onClick={onRowClick ? () => onRowClick(row) : undefined}
                                        style={{ cursor: onRowClick ? 'pointer' : 'default' }}
                                    >
                                        {showCheckBox && (
                                            <td className="text-center align-middle">
                                                <input
                                                    style={{ width: '20px', height: '20px', cursor: 'pointer' }}
                                                    type="checkbox"
                                                    checked={selectedRows.some((r) => r.id === row.id)}
                                                    onChange={() => handleRowSelect(row)}
                                                />
                                            </td>
                                        )}

                                        {tableHeader.map((col) => {
                                            let cellValue = row[col.key];

                                            if (col.key === 'dispenseDate' || col.key === 'destructionDate') {
                                                cellValue = formatDate(row[col.key]);
                                            } else if (col.key === 'dispensedQuantity') {
                                                cellValue = formatQuantity(row[col.key]);
                                            }

                                            return (
                                                <td key={col.key} className="text-nowrap">
                                                    {cellValue || '-'}
                                                </td>
                                            );
                                        })}
                                        {action && canDelete && (
                                            <td>
                                                <button
                                                    onClick={() => {
                                                        setSelectedDeleteItems(row.id);
                                                        setIsDeleteModalOpen(true);
                                                    }}
                                                    style={{
                                                        cursor: 'pointer',
                                                        outline: 'none',
                                                        border: 'none',
                                                        backgroundColor: '#f7c3d0',
                                                        borderRadius: '50%',
                                                        padding: '5px',
                                                        width: '25px',
                                                        height: '25px',
                                                        display: 'flex',
                                                        justifyContent: 'center',
                                                        alignItems: 'center',
                                                    }}>
                                                    <MdDeleteOutline style={{ fontSize: '18px' }} color="red" />
                                                </button>
                                            </td>
                                        )}
                                    </tr>
                                );
                            })}
                        </tbody>
                        {data.length === 0 && (
                            <tbody style={{ backgroundColor: "white" }}>
                                <tr>
                                    <td colSpan="20" className="text-center p-4">
                                        No data available
                                    </td>
                                </tr>
                            </tbody>
                        )}
                    </Table>
                </div>
            </div>
            <Pagination
                pageNumber={pageNumber}
                pageSize={pageSize}
                totalCount={totalCount}
                totalPages={totalPages}
                onPageChange={onPageChange}
            />
            <DeleteModal
                isDeleteModalOpen={isDeleteModalOpen}
                setIsDeleteModalOpen={setIsDeleteModalOpen}
                setSelectedRows={selectedRows}
                url={`${deleteUrl}${selectedDeleteItems}`}
                onDeleteSuccess={handleDeleteSuccessCallback}
                refetchData={refetchData}
            />
        </>
    );
}

export default DataTable;
